<ion-header collapse="fade" *ngIf="displayHeader">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button *ngIf="backButtonDefaultHref.value === undefined"></ion-menu-button>
      <ion-back-button *ngIf="backButtonDefaultHref.value !== undefined" [defaultHref]="backButtonDefaultHref.value"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ pageName.value }}</ion-title>
  </ion-toolbar>
  <ion-progress-bar type="indeterminate" *ngIf="isL | async"></ion-progress-bar>
</ion-header>
